// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"05fb37fefb80a85b","3159":"9dbff2e13711323a","7249":"8bb8e540cc8db618"}[chunkId] + ".css";
};